class ObfuscatedUserData {
    email;
    phone;
    constructor(email, phone) {
        this.email = email;
        this.phone = phone;
    }
}
export default ObfuscatedUserData;
